<template>
	<form id="add-user-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-email">Email</label>
					<input id="user-email" class="form-control" :class="{'is-invalid':emailError.length}" placeholder="email" v-model="emailValue"/>
					<div class="invalid-feedback" v-if="emailError">{{emailError}}</div>
				</div>
			</div>
			<div class="col-sm-6">
			</div>
		</div>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-first-name">First Name</label>
					<input id="user-first-name" class="form-control" placeholder="" v-model="firstNameValue"/>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-last-name">Last Name</label>
					<input id="user-last-name" class="form-control" placeholder="" v-model="lastNameValue"/>				</div>
			</div>
		</div>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="role-select">Role</label>
					<select id="role-select" class="form-control custom-select" v-model="roleValue">
						<option value="ReadOnly">Read Only</option>
						<option value="User">User</option>
						<option value="SiteAdmin">Site Admin</option>
						<option value="GlobalAdmin">Global Admin</option>
					</select>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="show-password-select">Show Password</label>
					<select id="show-password-select" class="form-control custom-select" v-model="showPasswordValue" :disabled="!isInRole('GlobalAdmin')">
						<option value="false">No</option>
						<option value="true">Yes</option>
					</select>
				</div>
			</div>
		</div>
	
		<div class="clearfix mt-1 mb-3">
			<div class="float-left ml-3">
				
			</div>
			<div class="float-right mr-3">
				<button type="submit" class="btn btn-outline-primary px-3">Add</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>

	</form>
</template>

<script>
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'AddUserForm',
		components: {Error},
		props: ['site', 'data'],
		data() {
			return {
				error: '',
				emailValue: '',
				roleValue:'',
				firstNameValue:'',
				lastNameValue:'',
				showPasswordValue:false,
				roleValue:'User',
				emailError:''
			}
		},
		methods: {
			closeForm() {
				this.$emit('close-add-user');
			},
			async saveForm() {
				
				try
				{
					//Validate email
					if (!this.emailValue.includes("@") || !this.emailValue.includes(".")) this.emailError = 'Please enter a valid email address.';		
					if (!this.emailValue) this.emailError = 'Please enter an email address.';		

					//Check if we have already added this email for this site
					const existing = this.data.filter(user => user.email.toLowerCase() === this.emailValue.toLowerCase());

					if (existing.length) this.emailError = 'This email has already been added for this site.';

					if (this.hasError) return;

					const newUser = {
						site: parseInt(this.site),
						email: this.emailValue,
						firstName: this.firstNameValue,
						lastName: this.lastNameValue,
						showPasswords: !!this.showPasswordValue,
						roles:[]
					};

					//Set roles
					const possibleRoles = ["ReadOnly", "User", "SiteAdmin", "GlobalAdmin"];
					
					for (let role of possibleRoles) {
						newUser.roles.push(role);
						if (this.roleValue == role) break;
					}

					//Remove the readonly role if has other roles
					if (newUser.roles.length > 1) newUser.roles.shift();

					const response = await api.post('system/user', newUser);	

					this.closeForm();
				}
				catch(err) {
					this.error = err + ""; //Get the string representation of the error		
				}
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return false;
				return store.state.user.roles.indexOf(role) > -1;
			}
		},
		computed: {
			hasError() {
				return this.emailError;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AddUserForm.vue